import { z } from "zod";
import { LookupListPage } from "./LookupListPage";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

interface Row { statusGroupCode: string; description: string; deleted: boolean; }
const schema = z.object({ statusGroupCode: z.string().min(1).max(20), description: z.string().min(1).max(100), deleted: z.boolean() });
type Form = z.infer<typeof schema>;

export function StatusGroupsPage() {
  return <LookupListPage<Row, Form>
    title="Status groups"
    apiPath="/api/lookups/status-groups"
    schema={schema}
    rowKey={(r) => r.statusGroupCode}
    columns={[
      { id: "code", header: "Code", accessor: (r) => r.statusGroupCode },
      { id: "desc", header: "Description", accessor: (r) => r.description },
    ]}
    toFormValues={(r) => ({ statusGroupCode: r.statusGroupCode, description: r.description, deleted: r.deleted })}
    toApiBody={(f) => f}
    blankFormValues={{ statusGroupCode: "", description: "", deleted: false }}
    fields={(f) => (
      <div className="space-y-3">
        <div><Label htmlFor="c">Code</Label><Input id="c" {...f.register("statusGroupCode")} /></div>
        <div><Label htmlFor="d">Description</Label><Input id="d" {...f.register("description")} /></div>
        <Button type="submit">Save</Button>
      </div>
    )}
  />;
}
